<template>
  <div>

    <b-button
    style="position: fixed; bottom:30px; right:15px;"
    class="btn-lg"
    v-on:click="share()"
    variant="primary">
{{ selectedItems.length }} Send PDF <i class="lni lni-share m-0"></i>
</b-button>

    <data-table-card
      :items="items"
      v-on:updateData="getCatalogueItems"
      :sortOptions="sortOptions"
      :filterOptions="filterOptions"
      :sort="sort"
      :isLoad="isLoad"
      :page="page"
      :rowsPerPage="rowsPerPage"
      :fromRow="fromRow"
      :toRow="toRow"
      :totalRows="totalRows"
      :lastPage="lastPage"
    >

     <template v-slot:header-buttons >
        <b-button
          class="ml-2"
            v-on:click="share()"
          variant="primary"
        >
        {{ selectedItems.length}}  <i class="lni lni-share m-0"></i>
        </b-button>
      </template>


      <template v-slot:cards="slotProps">
        <div class="row no-gutters">
          <div class="col-4 col-xl-3 p-1">
            <v-lazy-image
              v-if="slotProps.item.default_image"
              :src="slotProps.item.default_image.small"
              class="img-fluid"
            />

            <div
              v-if="slotProps.item.on_promotion == 1"
              class="mt-1 py-1 text-white font-weight-bold text-center bg-primary font-size-11"
            >
              Promotion
            </div>
             <div
                v-if="selectedItems.filter((x) => x.id == slotProps.item.id).length > 0"
              class="mt-1 py-1 text-white font-weight-bold text-center bg-success font-size-11"
            >
              Selected
            </div>
          </div>
          <div class="col-8 col-xl-7 p-3">
            <h5 class="font-weight-bold">{{ slotProps.item.name }}</h5>


            <span class="text-black-50">{{
              slotProps.item.product_group.name
            }}</span>
            <br />

            {{ slotProps.item.brand.name }}
            <span
              v-if="slotProps.item.brand.name != slotProps.item.supplier.name"
            >
              <br />
              <i class="lni lni-user font-size-11"></i>
              {{ slotProps.item.supplier.name }}
            </span>
            <div class="mt-2"><!-- --></div>

            <span
              v-if="selectedItems.filter((x) => x.id == slotProps.item.id).length == 0"
              v-b-tooltip.hover
              title="Add to PDF"
              v-on:click="addItem(slotProps.item)"
              class="text-primary table-action-icon ml-0"
            >
              <i class="lni lni-circle-plus"></i>
            </span>

              <span
              v-if="selectedItems.filter((x) => x.id == slotProps.item.id).length > 0"
              v-b-tooltip.hover
              title="Remove from PDF"
              v-on:click="removeItem(slotProps.item)"
              class="text-danger table-action-icon ml-0"
            >
              <i class="lni lni-trash"></i>
            </span>


            <router-link
              :to="{
                name: 'catalogue-share-item-show',
                params: { id: slotProps.item.id },
              }"
              v-b-tooltip.hover
              title="View"
              class="text-info table-action-icon ml-3"
            >
              <i class="lni lni-search-alt"></i>
            </router-link>
          </div>
        </div>
      </template>
    </data-table-card>

    <b-modal
      :hide-footer="true"
      :title="$route.meta.title"
      size="lg"
      v-model="sidebarToggle"
      :no-close-on-route-change="true"
      @hidden="$router.push({ name: 'catalogue-share' })"
      :lazy="true"
    >
      <router-view @catalogueShared="catalogueShared()"></router-view>
    </b-modal>

  </div>
</template>

<script>
import catalogueRepo from "@/api/repos/catalogueRepo";
import dataTableCard from "@/components/common/DataTableCard";

export default {
  components: {
    dataTableCard: dataTableCard,
  },

  data() {
    return {
      sidebarToggle: false,
      selectedItems: [],
      isLoad: false,
      sort:  { column: "on_promotion", label: "On Promotion", order: "desc" },
      sortOptions: [
        { column: "name", label: "Name Asc", order: "asc" },
        { column: "name", label: "Name Desc", order: "desc" },
        { column: "on_promotion", label: "On Promotion", order: "desc" },
        { column: "on_promotion", label: "Not on Promotion", order: "asc" },
        { column: "created_at", label: "Date Created Asc", order: "asc" },
        { column: "created_at", label: "Date Created Desc", order: "desc" },
      ],
      filterOptions: [],
      filterStr: null,
      page: 1,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 12,
      fromRow: 0,
      toRow: 0,
      totalRows: 0,
      lastPage: 0,
      items: [],
    };
  },
  mounted() {
    this.getCatalogueItems({
      sort: this.sort,
      filters: null,
      page: this.page,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 12,
      search: "",
    });
  },
  methods: {
    async getFilterData() {
      let { data } = await catalogueRepo.createGetData();

      this.filterOptions.push({
        column: "group-heading",
        label: "groups",
      });

      data.product_groups.forEach((p) => {
        this.filterOptions.push({
          column: "product_group_id",
          value: p.id,
          label: p.name,
        });
      });

      this.filterOptions.push({
        column: "group-heading",
        label: "suppliers",
      });

      data.suppliers.forEach((s) => {
        this.filterOptions.push({
          column: "supplier_id",
          value: s.id,
          label: s.name,
        });
      });

      this.filterOptions.push({
        column: "group-heading",
        label: "brands",
      });

      data.brands.forEach((b) => {
        this.filterOptions.push({
          column: "brand_id",
          value: b.id,
          label: b.name,
        });
      });
    },

    async getCatalogueItems(e) {
      this.isLoad = true;

      if (e.filters != null) {
        this.filterStr = e.filters;
      } else {
        this.filterStr = null;
      }

      try {
        let { data } = await catalogueRepo.catalogueItemsShareList(
          e.page,
          e.rowsPerPage,
          e.sort.column,
          e.sort.order,
          e.search,
          this.filterStr
        );

        this.items = data.catalogueItems.data;
        this.totalRows = data.catalogueItems.total;
        this.page = data.catalogueItems.current_page;
        this.fromRow = data.catalogueItems.from;
        this.toRow = data.catalogueItems.to;
        this.lastPage = data.catalogueItems.last_page;

        this.filterOptions = [];

        this.filterOptions.push({
          column: "on_promotion",
          value: "1",
          label: "On Promotion",
        });

        this.getFilterData();
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoad = false;
      }
    },

    addItem(item){
       this.selectedItems.push(item);
    },

    removeItem(item){
       this.selectedItems = this.selectedItems.filter((x) => x.id != item.id);
    },


    catalogueShared() {
      this.$bvToast.toast("Catalogue Shared", {
        title: "Success",
        autoHideDelay: 3000,
        variant: "success",
      });

      this.page = 1;
      this.sidebarToggle = false;
      this.getCatalogueItems({
        sort: this.sort,
        filters: null,
        page: this.page,
        rowsPerPage: localStorage.getItem("rowsPerPage")
          ? localStorage.getItem("rowsPerPage")
          : 12,
        search: "",
      });
    },

    share(){
        localStorage.setItem("catalogue-share-items",JSON.stringify(this.selectedItems))
         this.$router.push({name:'catalogue-share-pdf'})
    }
  },



  watch: {
    $route: {
      immediate: true,
      handler: function (newVal) {
        this.sidebarToggle = newVal.meta && newVal.meta.sidebarToggle;
      },
    },
  },
};
</script>
